import { ChevronFlip, Collapse, useSizeEffect } from '@subaio/components'

import { getNavigationId } from 'lib/getNavigationId'

import { Button } from './Button'
import { Code } from './Code'
import { Container } from './Container'
import { Content } from './Content'
import { Summary } from './Summary'

export type CategoryDefinition = {
	id: string
	title: string
	description: string
	examples: Array<string>
}

type Props = {
	category: CategoryDefinition
	isOpen: boolean
	onToggle: () => void
	onResize: (height: number) => void
}

export const Category = ({ category: { id, title, description, examples }, isOpen, onToggle, onResize }: Props) => (
	<Container
		id={getNavigationId(id)}
		ref={useSizeEffect((_, element) => onResize(element.getBoundingClientRect().height))}
	>
		<Button aria-expanded={isOpen} aria-controls={`${id}-details`} onClick={onToggle}>
			<Summary>
				<strong>{title}</strong>
				<Code>{id}</Code>
			</Summary>
			<ChevronFlip isActive={isOpen} aria-hidden />
		</Button>
		<Collapse isOpen={isOpen} id={`${id}-details`}>
			<Content>
				<p>{description}</p>
				<p>
					<strong>Examples</strong>
				</p>
				<ul>
					{examples.map((example) => (
						<li key={example}>{example}</li>
					))}
				</ul>
			</Content>
		</Collapse>
	</Container>
)
